// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"467":"d3517f21","595":"89064fc0","698":"aedf353d","787":"140fc388"}[chunkId] + ".chunk.js";
};